import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import * as serviceworker from './serviceWorker'

import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";

window.addEventListener("error", (event) => {
	console.error("[window.error] Uncaught error:", event.error || event.message);
	console.error("[window.error] File:", event.filename, "Line:", event.lineno, "Column:", event.colno);
});

window.addEventListener("unhandledrejection", (event) => {
	console.error("[window.unhandledrejection] Unhandled promise rejection:", event.reason);
});

ReactDOM.render(
	<CssBaseline>
		<ErrorBoundary>
			<App />
		</ErrorBoundary>
	</CssBaseline>,
	document.getElementById("root"),
	() => {
		if (typeof window.finishProgress === "function") {
			window.finishProgress();
		}
	}
);

serviceworker.register()
